"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

export const NoProduct = ({ clientSlug }: { clientSlug: string }) => {
  const router = useRouter();

  useEffect(() => {
    const timer = setTimeout(() => {
      router.push(`/${clientSlug}`);
    }, 1800);

    return () => {
      clearTimeout(timer);
    };
  }, [clientSlug]);

  return (
    <div className="flex w-full h-full items-center justify-center">
      <p className=" font-thin">
        The product you request does not exist for this organization,
        redirecting you to the main page...
      </p>
    </div>
  );
};
